import { IGlobalState } from '../../../Root/store/appReducer'

export const companyDashboardSelector = (state: IGlobalState) => state.dashboard.companyDashboard
export const employeesSelector = (state: IGlobalState) => state.dashboard.employees
